import { Text } from "@meditect/medibase-components";

export const FinancingInvalidMCFTokenProvidedError = () => {
  return <Text>Le token fourni a été rejété par la plateforme e-MECeF</Text>;
};
